import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/desarrollo-web/tu-contacto-profesional/TuContactoProfesionalClient.tsx");
